module.exports = __webpack_public_path__ + "img/foto-celso-cavallini.jpg";